(() => {
  if (window.__OH_H3_PARSER__) return;
  window.__OH_H3_PARSER__ = true;

  // console.log("[OH] h3 parser loaded");

  const cleanText = (s) =>
    (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const cleanTitle = (s) =>
    cleanText(s)
      .replace(/[\s:|•\-–—=]+$/g, "")
      .trim();

  // Case-insensitive + punctuation ignore for H3 matching
  const norm = (s) =>
    cleanTitle(s)
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[^\p{L}\p{N}\s]/gu, " ")
      .replace(/\s+/g, " ")
      .trim();

  function buildTable(rows) {
    const table = document.createElement("table");
    table.className = "oh-h3-table";
    const tbody = document.createElement("tbody");

    rows.forEach((row) => {
      if (row.type === "subhead") {
        const tr = document.createElement("tr");
        tr.className = "oh-h3-table__subhead";
        const th = document.createElement("th");
        th.colSpan = 2;
        th.textContent = row.label;
        tr.appendChild(th);
        tbody.appendChild(tr);
        return;
      }

      const tr = document.createElement("tr");
      if (row.isStrong) tr.classList.add("oh-h3-table__highlight");

      const tdL = document.createElement("td");
      const tdR = document.createElement("td");
      tdL.textContent = row.left;
      tdR.textContent = row.right;
      tr.appendChild(tdL);
      tr.appendChild(tdR);
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    return table;
  }

  function peelLeadingDimensions(label) {
    const l = cleanText(label);
    const m = l.match(/^(.+?\bW\b\s*x\s*[^:=]+?\bD\b\s*x\s*[^:=]+?\bH\b)\s+(.+)$/i);
    if (!m) return null;

    const dim = cleanText(m[1]);
    const rest = cleanText(m[2]);
    if (!dim || !rest) return null;

    return { dim, rest };
  }

  function splitManyLabelValue(text) {
    const t = cleanText(text).replace(/^\-\s*/, "");
    if (!t) return [];

    const re = /([A-Za-z][A-Za-z0-9\s&()\/\-'",.]{1,80}?)(?:\s*[:=]\s*)/g;

    const labels = [];
    let m;
    while ((m = re.exec(t)) !== null) {
      labels.push({ label: cleanText(m[1]), start: m.index, end: re.lastIndex });
      if (m.index === re.lastIndex) re.lastIndex++;
    }

    if (!labels.length) return [];

    const rows = [];
    const prefix = cleanText(t.slice(0, labels[0].start));
    if (prefix) rows.push({ type: "subhead", label: prefix });

    for (let i = 0; i < labels.length; i++) {
      const cur = labels[i];
      const next = labels[i + 1];
      const value = cleanText(t.slice(cur.end, next ? next.start : t.length));

      const peeled = peelLeadingDimensions(cur.label);
      if (peeled) {
        const last = rows[rows.length - 1];
        if (!last || last.type !== "subhead" || last.label !== peeled.dim) {
          rows.push({ type: "subhead", label: peeled.dim });
        }
        cur.label = peeled.rest;
      }

      if (cur.label && value) rows.push({ type: "row", left: cur.label, right: value });
      else if (cur.label && !value) rows.push({ type: "subhead", label: cur.label });
    }

    return rows;
  }

  function parseLi(li) {
    if (!li) return [];

    const strong = li.querySelector("strong");
    if (strong) {
      const left = cleanTitle(cleanText(strong.textContent).replace(/^\-\s*/, ""));

      const clone = li.cloneNode(true);
      const cs = clone.querySelector("strong");
      if (cs) cs.remove();

      const right = cleanText(clone.textContent);

      if (left && right) return [{ type: "row", left, right, isStrong: true }];
      if (left) return [{ type: "subhead", label: left }];
      if (right) return [{ type: "subhead", label: right }];
      return [];
    }

    const firstSpan = li.querySelector("span");
    if (firstSpan) {
      let leading = "";
      for (const node of Array.from(li.childNodes)) {
        if (node === firstSpan) break;
        if (node.nodeType === 3) leading += " " + node.textContent;
      }
      leading = cleanText(leading);

      const spansTmp = li.querySelectorAll("span");
      if (leading && spansTmp.length === 1) {
        const spanText = cleanText(firstSpan.textContent);

        if (/^[:=]\s*/.test(spanText) || /[:=]\s*/.test(spanText)) {
          const left = cleanTitle(leading);
          const right = cleanText(spanText.replace(/^[:=]\s*/, ""));
          if (left && right) return [{ type: "row", left, right }];
          if (left) return [{ type: "subhead", label: left }];
        }
      }
    }

    const spans = Array.from(li.querySelectorAll("span"));

    if (spans.length >= 2) {
      const leftRaw = cleanText(spans[0].textContent).replace(/^\-\s*/, "");
      const rightRaw = cleanText(spans.slice(1).map((s) => s.textContent).join(" "));

      const leftHasSep = /[:=]\s*$/.test(leftRaw);
      const rightHasSep = /^[:=]\s*/.test(rightRaw) || /[:=]\s*/.test(rightRaw);

      if ((leftHasSep || rightHasSep) && leftRaw) {
        const left = cleanTitle(leftRaw);
        const right = cleanText(rightRaw.replace(/^[:=]\s*/, ""));
        if (left && right) return [{ type: "row", left, right }];
        if (left) return [{ type: "subhead", label: left }];
        return [];
      }

      const t = cleanText(li.textContent);
      if (t) return [{ type: "subhead", label: cleanTitle(t) }];
      return [];
    }

    if (spans.length === 1) {
      const t = cleanText(spans[0].textContent);
      if (t) return [{ type: "subhead", label: cleanTitle(t) }];
      return [];
    }

    const t = cleanText(li.textContent);
    if (!t) return [];

    const many = splitManyLabelValue(t);
    if (many.length) return many;

    const idxColon = t.indexOf(":");
    const idxEq = t.indexOf("=");
    let idx = -1;
    if (idxColon > -1 && idxEq > -1) idx = Math.min(idxColon, idxEq);
    else idx = Math.max(idxColon, idxEq);

    if (idx > -1) {
      const left = cleanTitle(cleanText(t.slice(0, idx)).replace(/^\-\s*/, ""));
      const right = cleanText(t.slice(idx + 1));
      if (left && right) return [{ type: "row", left, right }];
      if (left && !right) return [{ type: "subhead", label: left }];
    }

    return [{ type: "subhead", label: cleanTitle(t) }];
  }

  function extractFromElement(el) {
    if (!el) return [];

    const tag = (el.tagName || "").toLowerCase();

    if (tag === "ul") {
      const rows = [];
      // :scope burada genelde OK, ama istemezsen li’leri direkt alabiliriz.
      el.querySelectorAll(":scope > li").forEach((li) => rows.push(...parseLi(li)));
      return rows;
    }

    if (tag === "li") return parseLi(el);

    const strong = el.querySelector && el.querySelector("strong");
    if (strong) {
      let left = cleanTitle(cleanText(strong.textContent).replace(/^\-\s*/, ""));

      const clone = el.cloneNode(true);
      const cs = clone.querySelector("strong");
      if (cs) cs.remove();
      const right = cleanText(clone.textContent);

      const peeled = peelLeadingDimensions(left);
      if (peeled) {
        const dimRow = { type: "subhead", label: peeled.dim };
        left = peeled.rest;
        if (left && right) return [dimRow, { type: "row", left, right, isStrong: true }];
        return [dimRow];
      }

      const many = splitManyLabelValue(right);
      if (many.length) {
        if (left) return [{ type: "subhead", label: left }, ...many];
        return many;
      }

      if (left && right) return [{ type: "row", left, right, isStrong: true }];
      if (left && !right) return [{ type: "subhead", label: left }];
    }

    const txt = cleanText(el.textContent);
    const many = splitManyLabelValue(txt);
    if (many.length) return many;

    const idxColon = txt.indexOf(":");
    const idxEq = txt.indexOf("=");
    let idx = -1;
    if (idxColon > -1 && idxEq > -1) idx = Math.min(idxColon, idxEq);
    else idx = Math.max(idxColon, idxEq);

    if (idx > -1) {
      const left = cleanTitle(cleanText(txt.slice(0, idx)).replace(/^\-\s*/, ""));
      const right = cleanText(txt.slice(idx + 1));
      if (left && right) return [{ type: "row", left, right }];
      if (left && !right) return [{ type: "subhead", label: left }];
    }

    if (txt) return [{ type: "subhead", label: cleanTitle(txt) }];
    return [];
  }

  function findH3(doc, wantedH3) {
    const wanted = norm(wantedH3);
    const h3s = Array.from(doc.querySelectorAll("h3"));

    return (
      h3s.find((h) => norm(h.textContent) === wanted) ||
      h3s.find((h) => norm(h.textContent).includes(wanted)) ||
      null
    );
  }

  // -----------------------------
  // ✅ CACHE: avoid re-parsing same HTML repeatedly
  // key = titleNorm + "||" + htmlLength + "||" + small hash
  // -----------------------------
  const __rowsCache = new Map();
  function hashTiny(str) {
    // tiny fast hash (not crypto)
    let h = 0;
    for (let i = 0; i < str.length; i += Math.ceil(str.length / 128) || 1) {
      h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    }
    return String(h);
  }

  function extractRowsBetweenH3(html, wantedH3) {
    const key = `${norm(wantedH3)}||${html.length}||${hashTiny(html)}`;
    if (__rowsCache.has(key)) return __rowsCache.get(key);

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const target = findH3(doc, wantedH3);
    if (!target) {
      __rowsCache.set(key, null);
      return null;
    }

    const rows = [];
    let n = target.nextSibling;

    while (n) {
      if (n.nodeType === 1 && n.tagName && n.tagName.toLowerCase() === "h3") break;

      if (n.nodeType === 1) {
        const tag = (n.tagName || "").toLowerCase();

        if (tag === "ul") {
          rows.push(...extractFromElement(n));
        } else {
          const ps = tag === "p" ? [n] : Array.from(n.querySelectorAll("p"));
          if (ps.length) ps.forEach((p) => rows.push(...extractFromElement(p)));
          else rows.push(...extractFromElement(n));
        }
      }

      n = n.nextSibling;
    }

    const filtered = rows.filter(
      (r) =>
        r &&
        ((r.type === "row" && r.left && r.right) || (r.type === "subhead" && r.label))
    );

    __rowsCache.set(key, filtered);
    return filtered;
  }

  function hydrateBlock(blockEl) {
    if (blockEl.__ohHydrated) return;
    blockEl.__ohHydrated = true;

    const rawTitle = blockEl.getAttribute("data-oh-h3-title") || "";
    const title = cleanTitle(rawTitle);
    const fallback = blockEl.getAttribute("data-oh-h3-fallback") === "true";

    const sourceTpl = blockEl.querySelector("template[data-oh-h3-source]");
    const out = blockEl.querySelector("[data-oh-h3-output]");
    if (!sourceTpl || !out) return;

    const html = sourceTpl.innerHTML || "";
    const rows = extractRowsBetweenH3(html, title);

    if (rows === null) {
      out.innerHTML = fallback
        ? html
        : `<div class="oh-h3-empty">No content found for "${rawTitle}".</div>`;
      return;
    }

    out.innerHTML = "";
    if (!rows.length) {
      out.innerHTML = `<div class="oh-h3-empty">No rows under "${rawTitle}".</div>`;
      return;
    }

    out.appendChild(buildTable(rows));
  }

  function setup() {
    document.querySelectorAll("details[data-cc-collapsible]").forEach((details) => {
      // ✅ IMPORTANT: bind listener only once
      if (details.__ohH3Bound) return;
      details.__ohH3Bound = true;

      details.addEventListener("toggle", () => {
        if (!details.open) return;

        // ✅ Only hydrate once per block (no forced re-parse each toggle)
        details.querySelectorAll("[data-oh-h3-extract]").forEach(hydrateBlock);
      });

      if (details.open) {
        details.querySelectorAll("[data-oh-h3-extract]").forEach(hydrateBlock);
      }
    });

    // no details wrapper or already open
    document.querySelectorAll("[data-oh-h3-extract]").forEach((el) => {
      const details = el.closest("details");
      if (!details || details.open) hydrateBlock(el);
    });
  }

  function bootOH(opts = {}) {
    try {
      // If section changed in editor, you MAY want to allow refresh:
      // clear hydration flags (cheap) but keep cache (fast)
      if (opts.resetHydration) {
        document.querySelectorAll("[data-oh-h3-extract]").forEach((el) => {
          el.__ohHydrated = false;
        });
      }
      setup();
    } catch (e) {
      // keep silent to avoid breaking PDP/editor
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bootOH(), { once: true });
  } else {
    bootOH();
  }

  // In Theme Editor, sections re-render: bind new nodes + allow re-hydrate
  document.addEventListener("shopify:section:load", () => bootOH({ resetHydration: true }));
  document.addEventListener("shopify:section:select", () => bootOH({ resetHydration: true }));
})();
